import { render, staticRenderFns } from "./restore.vue?vue&type=template&id=4d511d54&scoped=true"
import script from "./restore.vue?vue&type=script&lang=js"
export * from "./restore.vue?vue&type=script&lang=js"
import style0 from "./restore.vue?vue&type=style&index=0&id=4d511d54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d511d54",
  null
  
)

export default component.exports